/* Custom App for Trade 
    Author: Philip Diaz
    website: https://philipdiaz.info
*/
const MainTrade = function() {
    function MainTrade() {

        this.selector = {
            formstepemail: document.querySelector('.step-email'),
            formstepemailform: document.querySelector('.form-step-email'),
            formstepemailsubmit: document.querySelector('.form-step-email > button'),
            formstepemailtitlestart: document.querySelector('.step-email > h2 > span.start'),
            formstepemailtitlesecure: document.querySelector('.step-email > h2 > span.secure'),
            formstepemailpasswordhint: document.querySelector('.step-email > .password-hints'),
            formstepaboutyou: document.querySelector('.step-about-you'),
            stepemail: document.querySelector('.step-email'),
            stepaboutyou: document.querySelector('.step-about-you'),
            stepaboutyourbusiness: document.querySelector('.step-about-your-business'),
            stepconfirm: document.querySelector('.step-confirm'),
            formstepaboutyouform: document.querySelector('form.form-step-about-you'),
            formstepaboutyourbusinessform: document.querySelector('form.form-step-about-your-business'),
            stepemailcircle: document.querySelector('.circle-step-email'),
            stepaboutyourbusinesscircle: document.querySelector('.circle-step-about-your-business'),
            stepconfirmcircle: document.querySelector('.circle-step-confirm'),
            stepaboutyoucircle: document.querySelector('.circle-step-about-you'),
            abnverificationform: document.querySelector('form.form-abn-verification'),
            confirmemail: document.querySelector('.step-confirm > .confirmation-msg > p > span.customer-email'),
            erroremail: document.querySelector('.form-step-email > label.error-msg'),
            errorphone: document.querySelector('.form-step-about-you > label.error-msg'),
            formstepaboutyousubmit: document.querySelector('.form-step-about-you > button'),
            joinforfree: document.querySelector('.join-for-free'),
            tradebanner: document.querySelector('.trade-banner'),
            tradegrid: document.querySelector('.trade-grid'),
            formconfirmation: document.querySelector('form.confirmation-details')  
        }
        this.aboutyourbusiness = {
            name: document.querySelector('form.form-step-about-your-business > input[name="businessname"]'),
            tradingname: document.querySelector('form.form-step-about-your-business > input[name="tradingname"]'),
            postcode: document.querySelector('form.form-step-about-your-business > .grid-two-columns > input[name="postcode"]'),
            state: document.querySelector('form.form-step-about-your-business > .grid-two-columns > select[name="state"]'),
            loading: document.querySelector('.form-abn-verification .progress-bar'),
            searchstatus: document.querySelector('.search-status'),
            abnnumber: document.querySelector('.form-abn-verification > input[name="abn"]')
        }
        this.tobesavejson = {
            email: '',
            password: '',
            firstname: '',
            lastname: '',
            phone: '',
            abn: '',
            businessname: '',
            tradingname: '',
            address: '',
            suburb: '',
            postcode: '',
            statecode: '',
            statename: '',
            countryname: '',
            countrycode: '',
            businesssize: '',
            industry: '',
            abnverified: '',
            emailmarketing: 'SUBSCRIBED',
            smsmarketing: 'SUBSCRIBED'
        }

        this.selectorfocus = {
            email: document.querySelector('.form-step-email > input[name="email"]'),
            password: document.querySelector('.form-step-email > input[name="password"]'),
            firstname: document.querySelector('.form-step-about-you > input[name="firstname"]'),
            abn: document.querySelector('.form-abn-verification > input[name="abn"]'),
            phone: document.querySelector('.form-step-about-you > input[name="phone"]')
        }

        this.confirmation = {
            email: document.querySelector('.confirmation-details > input[name="confirm-email"]'),
            firstname: document.querySelector('.confirmation-details > input[name="confirm-firstname"]'),
            lastname: document.querySelector('.confirmation-details > input[name="confirm-lastname"]'),
            phone: document.querySelector('.confirmation-details > input[name="confirm-phone"]'),
            abn: document.querySelector('.confirmation-details > input[name="confirm-abn"]'),
            businessname: document.querySelector('.confirmation-details > input[name="confirm-business-name"]'),
            tradingname: document.querySelector('.confirmation-details > input[name="confirm-trading-name"]'),
            address: document.querySelector('.confirmation-details > input[name="confirm-address"]'),
            suburb: document.querySelector('.confirmation-details > input[name="confirm-suburb"]'),
            postcode: document.querySelector('.confirmation-details > input[name="confirm-postcode"]'),
            statename: document.querySelector('.confirmation-details > input[name="confirm-state-name"]'),
            statecode: document.querySelector('.confirmation-details > input[name="confirm-state-code"]'),
            businesssize: document.querySelector('.confirmation-details > input[name="confirm-business-size"]'),
            industry: document.querySelector('.confirmation-details > input[name="confirm-industry"]'),
            emailmarketing: document.querySelector('.confirmation-details > input[name="confirm-email-marketing"]'),
            smsmarketing: document.querySelector('.confirmation-details > input[name="confirm-sms-marketing"]'),
            finalconfirmation: document.querySelector('.final-confirmation'),
            confirmationdetails: document.querySelector('.confirmation-details'),
            confirmationmsg: document.querySelector('.confirmation-msg'),
            activationlink: document.querySelector('.activation-link')
        }

        this.stepback = {
            step: document.querySelector('.confirmation-details > button.go-back-step'),
            stepp: document.querySelector('.confirmation-details > button.go-back-stepp'),
            steppp: document.querySelector('.confirmation-details > button.go-back-steppp')
        }

        this.load();

    }

    MainTrade.prototype.load = function() {
        var _ = this;
        _.selectorfocus.email.focus();
        _.selector.formstepemailform.addEventListener("submit", event => {
            event.preventDefault();
            _.selector.formstepemail.classList.remove("active");
            _.selector.formstepaboutyou.classList.add("active");
            _.selector.stepemail.classList.remove("active");
            _.selector.stepemailcircle.classList.remove("active");
            _.selector.stepemailcircle.querySelector(".circle").textContent = '✓';
            _.selector.stepaboutyoucircle.classList.add("active");
            _.selector.stepaboutyou.classList.add("active");
            _.tobesavejson.email = event.target.email.value;
            _.tobesavejson.password = event.target.password.value;
            _.selectorfocus.firstname.focus();
        });
        _.selector.formstepemailsubmit.addEventListener("click", event => {
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(_.selector.formstepemailform.email.value)) {      
                _.verifyemail(_.selector.formstepemailform.email.value);  
            } else {
                event.preventDefault();
                _.selector.erroremail.textContent = 'Please enter valid email address.';
                _.selectorfocus.email.focus();
                return false;
            }
        });
        _.selector.formstepaboutyouform.addEventListener("submit", event => {
            event.preventDefault();
            if(/^\(?([0-9]{4})\)?[ ]?([0-9]{3})[ ]?([0-9]{3})$/.test(event.target.phone.value)) {  
                _.tobesavejson.firstname = event.target.firstname.value;
                _.tobesavejson.lastname = event.target.lastname.value;
                _.tobesavejson.phone = event.target.phone.value;    
                _.verifyphone(_.selector.formstepaboutyouform.phone.value);  
            } else {
                _.selector.errorphone.textContent = 'Please enter valid phone number (XXXX XXX XXX).';
                _.selectorfocus.phone.focus();
                return false;
            }
        });
        _.selector.abnverificationform.addEventListener("submit", event => {
            event.preventDefault();
            _.abncheck(_.selector.abnverificationform.abn.value);
        });
        _.selector.formstepaboutyourbusinessform.addEventListener("submit", event => {
            event.preventDefault();
            _.selector.formstepaboutyourbusinessform.querySelector(".progress-bar").classList.add("active");
            _.tobesavejson.abn = _.aboutyourbusiness.abnnumber.value;
            _.tobesavejson.businessname = event.target.businessname.value;
            _.tobesavejson.tradingname = event.target.tradingname.value;
            _.tobesavejson.address = event.target.address.value;
            _.tobesavejson.suburb = event.target.suburb.value;
            _.tobesavejson.postcode = event.target.postcode.value;
            _.tobesavejson.statecode = event.target.state[event.target.state.selectedIndex].value;
            _.tobesavejson.statename = event.target.state[event.target.state.selectedIndex].text;
            _.tobesavejson.countrycode = "AU";
            _.tobesavejson.countryname = "Australia";
            _.tobesavejson.businesssize = event.target.businessize.value;
            _.tobesavejson.industry = event.target.industry.value;
            _.tobesavejson.emailmarketing = event.target.emailmarketing.checked ? 'SUBSCRIBED' : 'UNSUBSCRIBED';
            _.tobesavejson.smsmarketing = event.target.smsmarketing.checked ? 'SUBSCRIBED' : 'UNSUBSCRIBED';
            _.selector.stepaboutyourbusiness.classList.remove("active");
            _.selector.stepaboutyourbusinesscircle.classList.remove("active");
            _.selector.stepaboutyourbusinesscircle.querySelector(".circle").textContent = '✓';
            _.selector.stepconfirmcircle.classList.add("active");
            _.selector.stepconfirm.classList.add("active");
            _.confirmation.email.value = _.tobesavejson.email;
            _.confirmation.firstname.value = _.tobesavejson.firstname;
            _.confirmation.lastname.value = _.tobesavejson.lastname;
            _.confirmation.phone.value = _.tobesavejson.phone;
            _.confirmation.abn.value = _.tobesavejson.abn;
            _.confirmation.businessname.value = _.tobesavejson.businessname;
            _.confirmation.tradingname.value = _.tobesavejson.tradingname;
            _.confirmation.address.value = _.tobesavejson.address;
            _.confirmation.suburb.value = _.tobesavejson.suburb;
            _.confirmation.postcode.value = _.tobesavejson.postcode;
            _.confirmation.statename.value = _.tobesavejson.statename;
            _.confirmation.statecode.value = _.tobesavejson.statecode;
            _.confirmation.businesssize.value = _.tobesavejson.businesssize;
            _.confirmation.industry.value = _.tobesavejson.industry;
            _.confirmation.emailmarketing.value = _.tobesavejson.emailmarketing;
            _.confirmation.smsmarketing.value = _.tobesavejson.smsmarketing;
            _.selector.formstepaboutyourbusinessform.querySelector(".progress-bar").classList.remove("active");
        });
        _.stepback.step.addEventListener("click", () => {
            _.selector.formstepemail.classList.add("active");
            _.selector.stepemail.classList.add("active");
            _.selector.stepemailcircle.classList.add("active");
            _.selector.stepemailcircle.querySelector(".circle").textContent = '1';
            _.selector.stepconfirm.classList.remove("active");
            _.selector.stepconfirmcircle.classList.add("active");
            _.selectorfocus.email.focus();
            window.scrollTo(0, 0);
        });
        _.stepback.stepp.addEventListener("click", () => {
            _.selector.formstepaboutyou.classList.add("active");
            _.selector.stepaboutyou.classList.add("active");
            _.selector.stepaboutyoucircle.classList.add("active");
            _.selector.stepaboutyoucircle.querySelector(".circle").textContent = '2';
            _.selector.stepconfirm.classList.remove("active");
            _.selector.stepconfirmcircle.classList.add("active");
            _.selectorfocus.firstname.focus();
            window.scrollTo(0, 0);
        });
        _.stepback.steppp.addEventListener("click", () => {
            _.selector.formstepaboutyourbusinessform.classList.add("active");
            _.selector.stepaboutyourbusiness.classList.add("active");
            _.selector.stepaboutyourbusinesscircle.classList.add("active");
            _.selector.stepaboutyourbusinesscircle.querySelector(".circle").textContent = '3';
            _.selector.stepconfirm.classList.remove("active");
            _.selector.stepconfirmcircle.classList.add("active");
            _.selectorfocus.firstname.focus();
            window.scrollTo(0, 0);
        });
        _.selector.formconfirmation.addEventListener("submit", event => {
            event.preventDefault();
            _.savejson(_.tobesavejson);
        });
        _.selector.joinforfree.addEventListener("click", () => {            
            _.selector.tradebanner.classList.remove("active");
            _.selector.tradegrid.classList.add("active");
            _.selector.stepemail.classList.add("active");
            window.scrollTo(0 ,0);
        });
    }

    MainTrade.prototype.abncheck = async function(id) {
        var _ = this;
        _.aboutyourbusiness.loading.classList.add("active");
        await fetch(`https://abr.business.gov.au/ABN/View?abn=${id}`)
        .then(response => response.text())
        .then(data => {
            const htmlParse = new DOMParser()
            .parseFromString(data, 'text/html');
            const result = htmlParse.querySelector("#content > div > h1").innerHTML;
            if(result.includes("Invalid ABN")) {
                _.tobesavejson.abn = id;
                _.tobesavejson.abnverified = `Invalid ABN, see for more details => https://abr.business.gov.au/ABN/View?abn=${id}`;
                _.aboutyourbusiness.searchstatus.textContent = 'Invalid ABN';
                _.aboutyourbusiness.loading.classList.remove("active");
                _.aboutyourbusiness.name.value = '';
                _.aboutyourbusiness.postcode.selectedIndex = 0;
                _.aboutyourbusiness.state.selectedIndex = 0;
                return false;               
            } else {
                _.aboutyourbusiness.searchstatus.textContent = 'Valid ABN';
                _.tobesavejson.abn = id;
                _.tobesavejson.abnverified = `Valid ABN, see for more details => https://abr.business.gov.au/ABN/View?abn=${id}`;
                const legalName = htmlParse.querySelector('[itemprop="legalName"]');
                _.aboutyourbusiness.name.value = legalName.textContent;
                const businessaddress = htmlParse.querySelector('[itemprop="addressLocality"]');
                _.aboutyourbusiness.postcode.value = businessaddress.textContent.match(/\d+/)[0];
                let extractstate = businessaddress.textContent.replace(businessaddress.textContent.match(/\d+/)[0],'');
                extractstate = extractstate.replace(' ','');
                _.aboutyourbusiness.state.value = extractstate;
                _.aboutyourbusiness.loading.classList.remove("active");                
            }            
        })
        .catch(error => {
            _.aboutyourbusiness.loading.classList.remove("active");
            console.error(error);
        });
    }

    MainTrade.prototype.savejson = async function(json) {
        var _ = this;
        _.confirmation.finalconfirmation.querySelector(".progress-bar").classList.add("active");
        await fetch('https://customapp.shopifymaster.dev/createuser', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(json)
        })
        .then(response => response.json())
        .then( async result => { 
            await fetch('https://customapp.shopifymaster.dev/accountverification', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(json)
            })
            .then(response => response.json())
            .then( async result => { 
                    _.confirmation.confirmationdetails.classList.remove("active");
                    _.selector.stepaboutyourbusinesscircle.classList.remove("active");
                    _.selector.stepaboutyourbusinesscircle.querySelector(".circle").textContent = '✓';
                    _.confirmation.confirmationmsg.classList.add("active");         
                    _.selector.stepconfirmcircle.classList.remove("active");
                    _.selector.stepconfirmcircle.querySelector(".circle").textContent = '✓';   
                    _.selector.confirmemail.textContent = _.tobesavejson.email;
                    _.confirmation.activationlink.textContent = result.data.customerCreate.customerUserErrors[0].message;
                    _.confirmation.finalconfirmation.querySelector(".progress-bar").classList.remove("active");
                    window.scrollTo(0, 0);                 
            })
            .catch(error => {
                _.confirmation.finalconfirmation.querySelector(".progress-bar").classList.remove("active");
                console.error(error);
            }); 
        })
        .catch(error => {
            _.confirmation.finalconfirmation.querySelector(".progress-bar").classList.remove("active");
            console.error(error);
        });
    }

    MainTrade.prototype.verifyemail = async function(email) {
        var _ = this;
        _.selector.formstepemailsubmit.querySelector('.progress-bar').classList.add("active");
        let raw = {
             email: email
        }
        await fetch('https://customapp.shopifymaster.dev/verifyemail', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(raw)
        })
        .then(response => response.json())
        .then(result => {
            if(result.data.customers.edges.length == 0) {
                _.selector.formstepemailform.password.classList.add("active");
                _.selector.formstepemailtitlesecure.classList.add("active");
                _.selector.formstepemailtitlestart.classList.remove("active");
                _.selector.formstepemailpasswordhint.classList.add("active");
                _.selector.erroremail.textContent = 'Valid email address, enter your password.';
                _.selectorfocus.password.focus();
                _.selector.formstepemailsubmit.querySelector('.progress-bar').classList.remove("active");
            } else {
                _.selector.formstepemailsubmit.querySelector('.progress-bar').classList.remove("active");
                _.selector.erroremail.textContent = 'Email address already in use.';
                _.selectorfocus.email.focus();
                return false;
            }
        })
        .catch(error => {
            _.selector.formstepemailsubmit.querySelector('.progress-bar').classList.remove("active");
            console.error(error);
        });
    }

    MainTrade.prototype.verifyphone = async function(phone) {
        var _ = this;
        _.selector.formstepaboutyousubmit.querySelector('.progress-bar').classList.add("active");
        let raw = {
             phone: phone
        }
        await fetch('https://customapp.shopifymaster.dev/verifyphone', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(raw)
        })
        .then(response => response.json())
        .then(result => {
            if(result.data.customers.edges.length == 0) {
                _.selector.stepaboutyou.classList.remove("active");
                _.selector.stepaboutyoucircle.classList.remove("active");
                _.selector.stepaboutyoucircle.querySelector(".circle").textContent = '✓';
                _.selector.stepaboutyourbusinesscircle.classList.add("active");
                _.selector.stepaboutyourbusiness.classList.add("active");
                _.selectorfocus.abn.focus();
                _.selector.formstepaboutyousubmit.querySelector('.progress-bar').classList.remove("active");
            } else {
                _.selector.errorphone.textContent = 'Phone is already in use.';
                _.selectorfocus.phone.focus();
                _.selector.formstepaboutyousubmit.querySelector('.progress-bar').classList.remove("active");
                return false;
            }            
        })
        .catch(error => {
            _.selector.formstepaboutyousubmit.querySelector('.progress-bar').classList.remove("active");
            console.error(error);
        });
    }

    MainTrade = new MainTrade;

}

MainTrade();